// /client/customer/src/utils/reservation/by-service/postAvailableTimesByService.ts
import apiConfig from '../../../apiConfig';

export type AvailableTimeSlot = {
  time: string;      // 'HH:mm'
  available: boolean;
};

export type PostAvailableTimesByServicePayload = {
  store_id: number;
  staff_id: number;
  date: string; // 'YYYY-MM-DD'
  duration_minutes: number;
  service_ids: number[];
};

export type PostAvailableTimesByServiceResponse = {
  slots: AvailableTimeSlot[];
};

export const postAvailableTimesByService = async (
  payload: PostAvailableTimesByServicePayload,
): Promise<AvailableTimeSlot[]> => {
  const { store_id, staff_id, date, duration_minutes, service_ids } = payload;

  if (!Number.isFinite(store_id) || store_id <= 0) throw new Error('Invalid store_id');
  if (!Number.isFinite(staff_id) || staff_id <= 0) throw new Error('Invalid staff_id');
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) throw new Error("date must be 'YYYY-MM-DD'");
  if (!Number.isFinite(duration_minutes) || duration_minutes <= 0) throw new Error('Invalid duration_minutes');
  if (!Array.isArray(service_ids) || service_ids.some((serviceId) => !Number.isFinite(serviceId) || serviceId <= 0)) {
    throw new Error('Invalid service_ids');
  }

  const res = await fetch(
    `${apiConfig.baseURL}/api/customer-app/reservation/by-service/available-times`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to fetch available times');
  }

  const data = (await res.json()) as PostAvailableTimesByServiceResponse;
  return Array.isArray(data.slots) ? data.slots : [];
};
